<template>
  <div class="row mb-2">
    <div class="col">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li
            v-for="(item, index) in items"
            :key="index"
            class="breadcrumb-item"
            :class="{ active: index === items.length - 1 }"
          >
            <span v-if="index === items.length - 1 || !item.to" class="wrap-text-200">
              {{ item.label }}
            </span>
            <a
              v-else
              href="javascript:void(0);"
              @click="$router.push(item.to)"
            >
              {{ item.label }}
            </a>
          </li>
        </ol>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
      validator: (value) =>
        value.every(
          (item) =>
            typeof item.label === "string" &&
            (typeof item.to === "string" || item.to === undefined)
        )
    }
  }
};
</script>

<style>
.breadcrumb {
  display: -ms-flexbox !important;
  display: flex !important;
  -ms-flex-wrap: wrap !important;
  flex-wrap: wrap !important;
  padding: .75rem 1rem !important;
  margin-bottom: 1rem !important;
  list-style: none !important;
  background-color: #e9ecef !important;
  border-radius: .25rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/PageBreadcrumb.vue